/** Typed store hooks, so no component ever writes `useSelector<RootState>` by hand. */

import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './store.js';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
